/**
 * @fileoverview `@puffin-core/error-handling` — the Spanish (ES) bundle, namespace #57 `errorHandling`.
 * @package @puffin-core/error-handling
 *
 * Mirrors `en.js` leaf for leaf; `_meta.js` records each leaf's provenance (the moved leaves keep pos-web's flags).
 *
 * @module @puffin-core/error-handling/strings/es
 */

export const ERROR_HANDLING_ES = Object.freeze({
  notifications: Object.freeze({
    errorTitle: Object.freeze({
      system: 'Error del sistema',
      ui: 'Error de interfaz',
      api: 'Error de API',
      database: 'Error de base de datos',
      validation: 'Error de validación',
      network: 'Error de red',
      security: 'Error de seguridad',
      businessRule: 'Error de regla de negocio',
      performance: 'Problema de rendimiento',
      unknown: 'Error',
    }),
    errorTitleInComponent: '{{title}} en {{component}}',
    messageUnavailable: 'Se produjo un error desconocido',
  }),
  display: Object.freeze({
    network: Object.freeze({
      title: 'Error de conexión',
      message: 'No se pudo conectar con el servidor. Revise su conexión a internet.',
    }),
    timeout: Object.freeze({
      title: 'Tiempo de espera agotado',
      message: 'La solicitud tardó demasiado en completarse. Inténtelo de nuevo.',
    }),
    authentication: Object.freeze({
      title: 'Se requiere autenticación',
      message: 'Inicie sesión para continuar.',
    }),
    forbidden: Object.freeze({
      title: 'Acceso denegado',
      message: 'No tiene permiso para realizar esta acción.',
    }),
    notFound: Object.freeze({
      title: 'No encontrado',
      message: 'No se encontró el recurso solicitado.',
    }),
    validation: Object.freeze({
      title: 'Error de validación',
      message: 'Revise los datos introducidos e inténtelo de nuevo.',
    }),
    server: Object.freeze({
      title: 'Error del servidor',
      message: 'Se produjo un error inesperado en el servidor. Inténtelo de nuevo más tarde.',
    }),
    unknown: Object.freeze({
      title: 'Error',
      message: 'Se produjo un error. Inténtelo de nuevo.',
    }),
  }),
});

export default ERROR_HANDLING_ES;
